// Widget → loader protokolü. widget/src/messaging.ts bunun AYNADIR; iki bundle
// ayrı derlendiği için kopya bilerek duruyor — birini değiştirince diğerini de
// değiştir.
export type WidgetPosition = "BOTTOM_RIGHT" | "BOTTOM_LEFT";

export const WIDGET_POSITIONS: readonly WidgetPosition[] = [
	"BOTTOM_RIGHT",
	"BOTTOM_LEFT",
];

// Kart açıldı/kapandı — loader iframe'i büyütür/küçültür.
export type WidgetResizeMessage = {
	source: "keenvoy-widget";
	type: "resize";
	state: "open" | "closed";
};

// Tenant'ın seçtiği launcher konumu (TK-16.1.1). Konumu widget taşır, çünkü
// temayı api'den yalnızca o çekiyor; loader'ın api adresi yok.
export type WidgetPositionMessage = {
	source: "keenvoy-widget";
	type: "position";
	position: WidgetPosition;
};

export type WidgetMessage = WidgetResizeMessage | WidgetPositionMessage;

export function isTrustedWidgetMessage(
	event: { origin: string; data: unknown },
	widgetOrigin: string,
): event is { origin: string; data: WidgetMessage } {
	if (event.origin !== widgetOrigin) {
		return false;
	}
	const { data } = event;
	if (data === null || typeof data !== "object") {
		return false;
	}
	// İki mesaj tipinin kesişimi `type: never` verirdi (literal'lar ayrık), bu
	// yüzden guard içinde alanlar tek tek okunuyor.
	const message = data as {
		source?: unknown;
		type?: unknown;
		state?: unknown;
		position?: unknown;
	};
	if (message.source !== "keenvoy-widget") {
		return false;
	}
	if (message.type === "resize") {
		return message.state === "open" || message.state === "closed";
	}
	if (message.type === "position") {
		return WIDGET_POSITIONS.includes(message.position as WidgetPosition);
	}
	return false;
}
